import { isDawnTheme, isDebutTheme } from '../../../utils';
import { initCartDebutHook } from './themes/debut';
import { initCartDawnHook } from './themes/dawn';

export default function initCartHandler() {
  if (isDebutTheme()) {
    initCartDebutHook();
  } else if (isDawnTheme()) {
    initCartDawnHook();
  }
}
